<div *ngIf="isEnabled" class="width-100 side-slider-wrapper">
    <div class="width-100 side-vertical-slider-wrapper">
        <div class="height-100 side-vertical-slider" [style.margin-left.%]="valueSlider"></div>
    </div>
    <twc-slider class="side-horizontal-slider" [ngClass]="{'invert-colors': areColorsInverted}" [min]="0" [max]="100"
        [step]="0.1" [(ngModel)]="valueSlider" [showLabel]="false" [showValue]="false" [showScale]="false"
        (input)="changeValueSlider($event)">
    </twc-slider>
</div>